export const NOTIFICATION_MODAL_ID = 'NOTIFICATION_MODAL_ID';
